export const flowTypes = [
  { name: 'Apply', value: 'vacancy-apply' },
  { name: 'Soft apply', value: 'vacancy-soft-apply' },
  { name: 'Orientation day apply', value: 'vacancy-orientation-day-apply' },
  { name: 'Contact form', value: 'contact-form' },
  { name: 'Share by email', value: 'share-by-email' },
  { name: 'Jobalert', value: 'company-jobalert' },
  { name: 'Newsletter', value: 'vacancy-newsletter-signup' },
]
